/**
 * @file    TableFootNote.tsx
 * @scope   VIEW
 * @summary Italic foot note under the table. Shared by DynamicTable and DynamicTableOld.
 * @produces JSX only
 * @sideEffects None.
 */
import React from 'react';

const TableFootNote: React.FC<{ footNote?: string }> = ({ footNote }) =>
  footNote ? <span className="table-grid-foot-note">{footNote}</span> : null;

export default React.memo(TableFootNote);
